import {
  Agent,
  AgentInLenderContext,
  AgentInSinglePaymentProviderContext,
  Lender,
  MerchantStructure,
} from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { AddOrEditAgentInLenderContextCredentialsDialog } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/components/AddOrEditAgentInLenderContextCredentialsDialog/AddOrEditAgentInLenderContextCredentialsDialog';
import { AddOrEditAgentInSinglePaymentProviderCredentialsDialog } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInSinglePaymentProviderContextTable/components/AddOrEditAgentInSinglePaymentProviderCredentials/AddOrEditAgentInSinglePaymentProviderCredentials';
import { CredentialsType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialsType';
interface EditCredentialsDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  agent: Agent;
  channelId: string;
  lenders: Lender[];
  merchantStructure: MerchantStructure;
  selectedCredentials: AgentInLenderContext | AgentInSinglePaymentProviderContext;
  credentialsType: CredentialsType;
}
export const EditCredentialsDialogFactory = ({
  opened,
  setOpened,
  toggleDialog,
  agent,
  channelId,
  lenders,
  merchantStructure,
  selectedCredentials,
  credentialsType,
}: EditCredentialsDialogProps) => {
  if (credentialsType === CredentialsType.AGENT_IN_LENDER_CONTEXT)
    return (
      <AddOrEditAgentInLenderContextCredentialsDialog
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
        lenders={lenders}
        channelId={channelId}
        merchantStructure={merchantStructure}
        agentId={agent.id}
        selectedAgentInLenderContext={selectedCredentials as AgentInLenderContext}
      />
    );
  if (credentialsType === CredentialsType.AGENT_IN_SINGLE_PAYMENT_PROVIDER_CONTEXT)
    return (
      <AddOrEditAgentInSinglePaymentProviderCredentialsDialog
        opened={opened}
        setOpened={setOpened}
        toggleDialog={toggleDialog}
        selectedAgentInSinglePaymentProviderContext={selectedCredentials as AgentInSinglePaymentProviderContext}
        agentId={agent.id}
      />
    );
  return null;
};
